module.exports = __webpack_public_path__ + "img/7b.2dd1c345.png";